/* eslint-disable new-cap */
export function audienceEvent(customer, forceEventFire) {
    if (!customer) {
        return;
    }

    var STORAGE_KEY = 'audienceEventFired',
        keys = ['ExistingCustomer', 'HasActiveSubscription', 'PrimaryDiscipline', 'ATSSmartPaks'];

    if (sessionStorage.getItem(STORAGE_KEY) !== 'true' || forceEventFire) {
        event(
            'Audience',
            keys.reduce(function(audience, key) {
                audience[key] = customer[key];

                return audience;
            }, {})
        );

        sessionStorage.setItem(STORAGE_KEY, 'true');
    }
}

export function indentity(email) {
    if (email && window.DY && window.DY.API && window.DYO) {
        window.DY.API('identify', {
            uid: window.DYO.dyhash.sha256(email),
            type: 'he'
        });
    }
}

export function searchEvent(searchText) {
    event('Keyword Search', {
        dyType: 'keyword-search-v1',
        keywords: searchText
    });
}

export function event(eventName, eventObject) {
    if (window.DY && window.DY.API) {
        var eventProperties = {};

        Object.keys(eventObject).forEach(function(key) {
            if (typeof eventObject[key] === 'function') {
                return;
            }
            if (typeof eventObject[key] === 'undefined' || typeof eventObject[key] === 'number') {
                eventProperties[key] = eventObject[key];
            } else {
                eventProperties[key] = eventObject[key].toString();
            }
        });

        // eslint-disable-next-line new-cap
        window.DY.API('event', {
            name: eventName,
            properties: eventProperties
        });
    }
}

export function signUpEvent(email) {
    const hashedEmail = getHashedEmail(email);
    window.DY.API('event', {
        name: 'Signup',
        properties: {
            dyType: 'signup-v1',
            hashedEmail: hashedEmail
        }
    });
}

export function newsLetterSubscriptionEvent(email) {
    var hashedEmail = getHashedEmail(email);
    window.DY.API('event', {
        name: 'Newsletter Subscription',
        properties: {
            dyType: 'newsletter-subscription-v1',
            hashedEmail: hashedEmail
        }
    });
}

export function loginEvent(email) {
    if(!window.DY || !window.DYO){
        return;
    }

    window.DY.API('event', {
        name: 'Login',
        properties: {
            dyType: 'login-v1',
            hashedEmail: getHashedEmail(email)
        }
    });
}

export function getHashedEmail(emailAddress) {
    return window.DYO.dyhash.sha256(emailAddress.toLowerCase());
}
